import type { ColumnChartDataItems } from "pro-features/components/Chart/src/types";
import type { ReactNode } from "react";
import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { getFlattenSelectedCategory } from "app/pages/industry-analysis/common/getSelectedCategory";

const { carbon } = colorsPalettes;

const Label = styled.span`
    ${setFontVariant("dataTable1", carbon[400])};
    font-weight: 400;
`;

const BoldLabel = styled.span`
    ${setFontVariant("dataTable1", carbon[500])};
`;

export const getCategoriesItems = (series: ColumnChartDataItems): Array<ReactNode> => {
    const flattenedCategory = getFlattenSelectedCategory();
    const categories = series.map(({ displayText }, index) => {
        const isSelected = flattenedCategory.text === displayText;
        const Component = isSelected ? BoldLabel : Label;
        return <Component>{displayText}</Component>;
    });
    return categories;
};
